import React, { createRef, memo, useEffect, useState } from 'react';
import HighchartsReact from 'highcharts-react-official';
import Highcharts from 'highcharts/highstock';

require('highcharts/modules/map')(Highcharts);

const VolumeChart = (props) => {
  const [data, setData] = useState({
    buy: [],
    sell: [],
  });

  const [currentPrice, setCurrentPrice] = useState(0);

  const getMinMax = (mathFunc, array, property) => {
    return Math[mathFunc].apply(array, array.map(function ( item ) {
      return item[ property ];
    }));
  };

  const getDefaultZoom = () => {
    let buyMin;
    let buyMax;
    let buyRange;
    let sellMin;
    let sellMax;
    let sellRange;
    let defaultZoom = {
      min: 0,
      max: 0,
    };

    if (props && props.orders && props.orders.liquidity) {

      if (props.orders.liquidity.BUY && props.orders.liquidity.BUY.length) {
        buyMin = getMinMax('min', props.orders.liquidity.BUY, 'price');
        buyMax = getMinMax('max', props.orders.liquidity.BUY, 'price');
        buyRange = Number(buyMax) - Number(buyMin);
      }

      if (props.orders.liquidity.SELL && props.orders.liquidity.SELL.length) {
        sellMin = getMinMax('min', props.orders.liquidity.SELL, 'price');
        sellMax = getMinMax('max', props.orders.liquidity.SELL, 'price');
        sellRange = Number(sellMax) - Number(sellMin);
      }

    }

    if (buyMin && sellMin && buyRange) {
      if (buyRange > sellRange) {
        defaultZoom = {
          // min: Number(sellMax) - Number(sellRange),
          // max: Number(buyMax),
          min: Number(buyMax) - Number(sellRange),
          max: Number(sellMax),
        };
      } else {
        defaultZoom = {
          min: Number(buyMin),
          max: Number(sellMin) + Number(buyRange),
        };
      }
    }
    return defaultZoom;
  };

  const chartRef = createRef();

  useEffect(() => {
    let useBuy;
    let useSell;
    if (props && props.orders && props.orders.liquidity) {
      useBuy = [...props.orders.liquidity.BUY];
      useSell = [...props.orders.liquidity.SELL];
      setData({
        buy: useBuy.reverse(),
        sell: useSell,
      });
    }
  }, [props, props.orders]);

  useEffect(() => {
    if (props.orders && props.orders.latest && props.orders.latest.length) {
      const { latest } = props.orders;
      const latestPrice = latest[latest.length - 1];
      setCurrentPrice(parseFloat(latestPrice.price));
    }
  }, [props.orders, props.orders.latest]);

  const buySeries = data.buy.map((buy) => [parseFloat(buy.price), parseFloat(buy.sum)]);
  const sell = data.sell.map((buy) => [parseFloat(buy.price), parseFloat(buy.sum)]);

  let themePref = 'DARK';
  if (localStorage.getItem('_vt_theme')) {
    themePref = localStorage.getItem('_vt_theme');
  }
  let textColour = '#ffffff';
  if (themePref === 'LIGHT') {
    textColour = '#2e2e45';
  }

  return (
    <>
      <div id="father">
        <div id="current-price">
          Latest price: {currentPrice}
        </div>
        <HighchartsReact
          constructorType={'chart'}
          highcharts={Highcharts}
          ref={chartRef}
          options={{
            chart: {
              type: 'area',
              zoomType: 'x',
              panning: true,
              panKey: 'shift',
              marginBottom: 50,
              backgroundColor: 'rgba(0, 2, 4, 0)',
              events: {
                load() {
                  const chart = this;
                  const xAxis = chart.xAxis[0];
                  const yAxis = chart.yAxis[0];
                  const defaultZoom = getDefaultZoom();
                  xAxis.setExtremes(defaultZoom.min, defaultZoom.max);
                },
                selection(event) {
                  if (!event.xAxis) {
                    setTimeout(() => {
                      const chart = this;
                      const xAxis = chart.xAxis[0];
                      const defaultZoom = getDefaultZoom();
                      xAxis.setExtremes(defaultZoom.min, defaultZoom.max);
                    }, 1);
                  }
                },
              },
            },
            mapNavigation: {
              enableMouseWheelZoom: true,
            },
            title: '',
            credits: false,

            xAxis: {
              offset: 0,
              lineColor: '#374964',
              tickWidth: 0,
              tickLength: 5,
              tickColor: '#374964',
              labels: {
                style: {
                  fontFamily: 'DroidSansMono',
                  color: textColour,
                  fontSize: '12px',
                },
              },
              title: {
                text: 'Price',
                style: {
                  fontFamily: 'ProximaNova',
                  color: textColour,
                  fontSize: '14px',
                },
              },
            },
            yAxis: [
              {
                lineWidth: 0,
                gridLineWidth: 0,
                title: {
                  text: 'Volume',
                  style: {
                    fontFamily: 'ProximaNova',
                    color: textColour,
                    fontSize: '14px',
                  },
                },
                tickWidth: 0,
                tickLength: 5,
                tickPosition: 'inside',
                tickColor: '#374964',
                labels: {
                  align: 'right',
                  x: -8,
                  style: {
                    fontFamily: 'DroidSansMono',
                    color: textColour,
                    fontSize: '12px',
                  },
                },
              },
              {
                opposite: true,
                linkedTo: 0,
                lineWidth: 0,
                gridLineWidth: 0,
                title: null,
                tickWidth: 0,
                tickLength: 5,
                tickPosition: 'inside',
                tickColor: '#374964',
                labels: {
                  align: 'left',
                  x: 8,
                  style: {
                    fontFamily: 'DroidSansMono',
                    color: textColour,
                    fontSize: '12px',
                  },
                },
              },
            ],
            legend: {
              enabled: false,
            },
            plotOptions: {
              area: {
                lineWidth: 1,
                step: 'center',
              },
            },
            tooltip: {
              formatter: function () {
                return 'Volume: <span class="label-num">' + this.y + '</span> <br>Price: <span class="label-num">' + this.x + '</span>';
              },
              shared: true,
            },
            series: [{
              name: 'Asks',
              data: sell,
              color: 'rgb(255, 99, 51)',
              fillColor: {
                linearGradient: {
                  x1: 0,
                  y1: 0,
                  x2: 0,
                  y2: 1,
                },
                stops: [
                  [0, 'rgba(255, 99, 51, 0.3)'],
                  [1, 'rgba(255, 99, 51, 0)'],
                ],
              },
            }, {
              name: 'Bids',
              data: buySeries,
              color: 'rgb(78, 199, 138)',
              fillColor: {
                linearGradient: {
                  x1: 0,
                  y1: 0,
                  x2: 0,
                  y2: 1,
                },
                stops: [
                  [0, 'rgba(78, 199, 138, 0.3)'],
                  [1, 'rgba(78, 199, 138, 0)'],
                ],
              },
            }],
          }}
        />
      </div>
    </>
  );
};

export default memo(VolumeChart);
